/* Brand My Cap: phone & tablet helpers for the Style + Colour filter (works alongside bmc-filter.js).
   1. A sticky "Show 12 results" button at the bottom of the open filter: the count updates as boxes are ticked;
      tapping it closes the filter and scrolls to the first product.
   2. Removable tags above the products for each active filter, plus "Clear all".
   3. Style pages (Truckers, Beanies …) reload when a filter changes; the filter reopens where it was so more can be added. */
(function () {
  if (window.__bmcFilterUi) return;
  window.__bmcFilterUi = true;
  var KEY = 'bmcFilterReopen';
  function small() { return window.matchMedia('(max-width: 989px)').matches; }

  function init() {
    var box = document.querySelector('details[data-bmc-filter].medium-hide') || document.querySelector('details[data-bmc-filter]');
    if (!box) return;
    var apply = box.querySelector('[data-bmc-apply]');
    var preset = (box.getAttribute('data-preset') || '').split(',').filter(Boolean);
    var total = parseInt(box.getAttribute('data-total'), 10) || 0;
    var waiting = false;

    function count() {
      var grid = document.getElementById('product-grid');
      if (waiting || (grid && grid.classList.contains('bmc-filter-loading'))) return null;
      var note = document.querySelector('.bmc-filter__results');
      if (note) { var m = note.textContent.match(/\d+/); if (m) return +m[0]; }
      return total;
    }

    function label(i) {
      var l = i.closest('label');
      var t = l && l.querySelector('.bmc-filter__label');
      return t ? t.textContent.trim() : i.value;
    }

    function chips() {
      var host = document.querySelector('.bmc-chips');
      var on = [].slice.call(box.querySelectorAll('input[data-group]:checked')).filter(function (i) {
        return !(i.getAttribute('data-group') === 'style' && preset.indexOf(i.value) > -1);
      });
      var sig = on.map(function (i) { return i.getAttribute('data-group') + ':' + i.value; }).join('|');
      if (host && host.getAttribute('data-sig') === sig && host.isConnected) return;
      if (!on.length) { if (host) host.remove(); return; }
      if (!host) {
        var anchor = document.querySelector('.bmc-filter__results') || document.getElementById('product-grid');
        if (!anchor) return;
        host = document.createElement('div');
        host.className = 'bmc-chips';
        host.setAttribute('aria-label', 'Active filters');
        anchor.parentNode.insertBefore(host, anchor);
      }
      host.setAttribute('data-sig', sig);
      host.innerHTML = '';
      on.forEach(function (i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bmc-chip';
        b.setAttribute('aria-label', 'Remove filter ' + label(i));
        b.innerHTML = '<em></em><span aria-hidden="true">&times;</span>';
        b.firstChild.textContent = label(i);
        b.addEventListener('click', function () { i.click(); });
        host.appendChild(b);
      });
      var clr = box.querySelector('[data-bmc-clear]');
      if (clr && on.length > 1) {
        var c = document.createElement('button');
        c.type = 'button';
        c.className = 'bmc-chip bmc-chip--clear';
        c.textContent = 'Clear all';
        c.addEventListener('click', function () { clr.click(); });
        host.appendChild(c);
      }
    }

    function refresh() {
      if (apply) {
        var n = count();
        var txt = n === null ? 'Updating…' : n === 0 ? 'No matches – try fewer filters' : 'Show ' + n + (n === 1 ? ' result' : ' results');
        apply.classList.toggle('is-empty', n === 0);
        if (apply.textContent !== txt) apply.textContent = txt;
      }
      chips();
    }

    box.addEventListener('change', function (e) {
      if (!e.target.matches('input[data-group]')) return;
      waiting = true;
      try { if (small()) sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), y: box.getBoundingClientRect().top })); } catch (x) {}
      refresh();
      setTimeout(function () { waiting = false; refresh(); }, 350);
    });

    if (apply) apply.addEventListener('click', function () {
      if (apply.classList.contains('is-empty')) return;
      try { sessionStorage.removeItem(KEY); } catch (x) {}
      box.open = false;
      var target = document.querySelector('.bmc-chips') || document.querySelector('.bmc-filter__results') || document.getElementById('product-grid');
      if (target) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
    });

    var pg = document.getElementById('ProductGridContainer') || document.body;
    new MutationObserver(function (recs) {
      if (waiting) return;
      if (recs.every(function (r) { var t = r.target.nodeType === 1 ? r.target : r.target.parentNode; return t && t.closest && t.closest('.bmc-chips'); })) return;
      refresh();
    }).observe(pg, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });

    /* Reopen the filter after a style page reloaded because a box was ticked */
    try {
      var r = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      sessionStorage.removeItem(KEY);
      if (r && Date.now() - r.t < 15000 && small()) {
        box.open = true;
        requestAnimationFrame(function () { window.scrollTo(0, box.getBoundingClientRect().top + window.scrollY - (r.y || 0)); });
      }
    } catch (x) {}

    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
